// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { MessageModel } from "@insite/client-framework/Types/ApiModels";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
import NotificationsPanel from "@store/Library/Components/Notifications/NotificationsPanel";
import React, { FC } from "react";
import { css } from "styled-components";

export const notificationsMobilePanelDrawerStyles: DrawerPresentationProps = {
    mergeCss: true,
    cssOverrides: {
        drawerBody: css`
            width: 100%;
            max-width: 100%;
        `,
        drawerContent: css`
            flex: 1 1 auto;
            min-height: 0;
            overflow: hidden;
            display: flex;
            flex-direction: column;
        `,
    },
};

export interface NotificationsMobilePanelProps {
    isOpen: boolean;
    onClose: () => void;
    messages: MessageModel[];
    unreadCount: number;
    isLoading: boolean;
    hasLoaded: boolean;
    /** Session locale, for localized relative time. */
    language?: string;
    /** Page type appended to each action link as `returnPage` (see NotificationItem). */
    actionReturnPageType?: string;
    /** Called when an action link is clicked (before navigation) — used to close the panel. */
    onActionClick?: () => void;
    onSetReadStatus: (messages: MessageModel[], isRead: boolean) => void;
}

/**
 * Full-screen mobile presentation of the Notifications surface. Reuses the shared
 * NotificationsPanel body inside a Drawer, which provides the scrim, underlying-page scroll lock,
 * focus management and ESC/close handling. The X close lives in the drawer's top bar above the panel.
 */
const NotificationsMobilePanel: FC<NotificationsMobilePanelProps> = ({
    isOpen,
    onClose,
    messages,
    unreadCount,
    isLoading,
    hasLoaded,
    language,
    actionReturnPageType,
    onActionClick,
    onSetReadStatus,
}) => (
    <Drawer
        position="right"
        isOpen={isOpen}
        handleClose={onClose}
        headline={translate("Notifications")}
        hideHeadline
        contentLabel={translate("Notifications")}
        closeButtonAccessibleText={translate("Close")}
        drawerContentForwardAs="div"
        data-test-selector="notifications_mobilePanel"
        {...notificationsMobilePanelDrawerStyles}
    >
        <NotificationsPanel
            messages={messages}
            unreadCount={unreadCount}
            isLoading={isLoading}
            hasLoaded={hasLoaded}
            language={language}
            actionReturnPageType={actionReturnPageType}
            onActionClick={onActionClick}
            onSetReadStatus={onSetReadStatus}
        />
    </Drawer>
);

export default NotificationsMobilePanel;
